var _path, _path2, _path3, _path4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 49,
    viewBox: "0 0 62 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.379 35.7793C33.9989 35.347 34.8096 35.3011 35.4744 35.6606L55.4146 46.4446C56.3276 46.9384 55.9769 48.3242 54.9389 48.3242H18.5723C17.5937 48.3242 17.1976 47.0638 18.0003 46.504L33.379 35.7793Z",
    fill: "#7DA9E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5214 16.2332C18.734 15.2765 19.6086 14.6147 20.5871 14.6703L50.8269 16.3865C51.7722 16.4401 52.1206 17.6554 51.3472 18.2016L14.0048 44.58C13.258 45.1076 12.2533 44.4389 12.4516 43.5463L18.5214 16.2332Z",
    fill: "#B1CBF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8017 33.3388C38.1508 32.9862 38.0953 32.0732 38.6988 31.6444L55.1177 19.9783C55.7122 19.5559 56.5443 19.8914 56.6795 20.6081L61.0003 43.5081C61.1565 44.3358 60.282 44.974 59.5414 44.5728L38.8017 33.3388Z",
    fill: "#7DA9E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0056 24L16.6381 17.5544C15.3789 16.2806 14.5211 14.6573 14.1734 12.8899C13.8256 11.1225 14.0035 9.29039 14.6845 7.62534C15.3655 5.9603 16.5191 4.5371 17.9993 3.53578C19.4794 2.53446 21.2197 2 23 2C24.7803 2 26.5206 2.53446 28.0007 3.53578C29.4809 4.53711 30.6345 5.9603 31.3155 7.62534C31.9965 9.29039 32.1744 11.1225 31.8266 12.8899C31.4789 14.6573 30.6211 16.2806 29.3619 17.5544L23.0056 24Z",
    fill: "#2F75DA",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 11,
    r: 3,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/addressIcon.196611184f768d26ab94f612329b4149.svg";
export { ForwardRef as ReactComponent };